import { render, staticRenderFns } from "./siteFooter.vue?vue&type=template&id=49d5ac90&"
import script from "./siteFooter.vue?vue&type=script&lang=js&"
export * from "./siteFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports